import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "match-product-action-widget" }

import { OioButton, OioForm, OioFormItem, OioModal, OioInput, type FormItemRule } from '@kunlun/vue-ui-antd';
import { computed, defineComponent, reactive, ref } from 'vue';
import { OioTable, OioColumn, TableSize, type RuntimeModel, ClickResult } from '@kunlun/dependencies';
import { matchProductApi, type IMatchProductApiRst } from './service';
interface IProps {
  setFormData: (val: any) => Promise<ClickResult>;
  validationAndFillFunction: (val: string) => Promise<IMatchProductApiRst>;
  isSelfOperated: boolean;
}
type FormState = {
  code: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'MatchProducts',
  props: {
    setFormData: null,
    validationAndFillFunction: null,
    isSelfOperated: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { setFormData: (val: any) => Promise<ClickResult>, validationAndFillFunction: (val: string) => Promise<IMatchProductApiRst>, isSelfOperated: boolean }


const formState = reactive<FormState>({
  code: '' //都使用code
});
const codeName = computed(() => (props.isSelfOperated ? 'ERP编码' : '69码'));
const rules: Record<string, FormItemRule[]> = {
  code: [{ required: true, message: `请输入${codeName.value}` }]
};
const formRef = ref();

const tips = `请输入商品${codeName.value} ，可输入多个编码匹配，编码之间用英文逗号隔开`;
const hasError = computed(() => errorList.value.length > 0); //是否有错误信息
const errorPopupShow = ref(false); //错误信息弹窗展示
const matchProductPopupShow = ref(false);
const confirmLoading = ref(false); //确定按钮loading
// 140028535,140022809
//开始匹配
const startMatching = async () => {
  try {
    await formRef.value?.validate();
    confirmLoading.value = true;
    const res = await props.validationAndFillFunction(formState.code);
    errorList.value = res.errorInfos;
    errorPopupShow.value = res.errorInfos.length > 0;
    matchProductPopupShow.value = false;
    props.setFormData(res);
  } catch (error) {
    console.error(error);
  } finally {
    confirmLoading.value = false;
    formState.code = '';
  }
};
const errorList = ref<string[]>([]); //错误信息
const tableData = computed(() => {
  return errorList.value.map((i) => ({ errorInfo: i }));
});
const openMatchProductPopup = () => {
  matchProductPopupShow.value = true;
};
const openErrorPopup = () => {
  errorPopupShow.value = true;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(OioButton), {
      type: "primary",
      size: "small",
      onClick: openMatchProductPopup
    }, {
      default: _withCtx(() => [
        _createTextVNode(" 匹配商品 ")
      ]),
      _: 1
    }),
    (_unref(hasError))
      ? (_openBlock(), _createBlock(_unref(OioButton), {
          key: 0,
          type: "primary",
          size: "small",
          onClick: openErrorPopup
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 异常信息 ")
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(OioModal), {
      visible: matchProductPopupShow.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((matchProductPopupShow).value = $event)),
      title: "匹配商品",
      height: "medium",
      maskClosable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          type: "primary",
          onClick: startMatching
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 开始匹配 ")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(OioForm), {
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          data: formState,
          "label-width": 80
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(OioFormItem), {
              name: "code",
              required: "",
              extra: tips,
              label: _unref(codeName)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(OioInput), {
                  value: formState.code,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.code) = $event)),
                  placeholder: '请输入' + _unref(codeName)
                }, null, 8, ["value", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(OioModal), {
      visible: errorPopupShow.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((errorPopupShow).value = $event)),
      title: "错误信息",
      height: "medium",
      maskClosable: false
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(OioTable), {
          data: _unref(tableData),
          size: _unref(TableSize).small
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(OioColumn), {
              field: "errorInfo",
              label: "异常信息",
              width: "100%"
            })
          ]),
          _: 1
        }, 8, ["data", "size"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})